import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons"
import { faGithub } from "@fortawesome/free-brands-svg-icons"
import { faEnvelope } from "@fortawesome/free-regular-svg-icons"

export default function Block() {
  return (
    <div className="min-h-screen bg-black text-white font-mono flex justify-center items-start py-10 px-4">
      <div className="w-full max-w-5xl bg-gray-950 border border-pink-500/40 rounded-lg p-4 shadow-2xl">

        {/* header */}
        <header className="text-center mb-4">
          <h1 className="text-5xl font-bold text-indigo-400 tracking-widest">aileena xie</h1>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-4">
          {/* intro */}
          <div className="space-y-4">
            <div className="bg-gray-900 p-4 rounded-md border border-pink-500/30">
              <h2 className="text-xl text-pink-400 mb-2 font-bold">cs @ mcgill university</h2>
              <p className="mb-2">hi there &#128075; i'm based in montreal, canada &#127809;.</p>
              <p className="mb-2">i code sometimes.</p>
            </div>

            {/* experience */}
            <div className="bg-gray-900 p-4 rounded-md border border-pink-500/30 space-y-5">
              <h2 className="text-lg text-pink-400 mb-2"> experience</h2>
              <div className="relative group pl-8">
                <span className="absolute left-0 top-0 text-xl transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110">🌸</span>
                <div className="font-bold text-400">software engineer</div>
                <div className="text-indigo-400">google (gmail)</div>
                <div className="text-sm text-gray-400">2025</div>
              </div>

              <div className="relative group pl-8">
                <span className="absolute left-0 top-0 text-xl transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110">🌸</span>
                <div className="font-bold text-400">software developer</div>
                <div className="text-indigo-400">coveo (content ingestion)</div>
                <div className="text-sm text-gray-400">2024</div>
              </div>

              <div className="relative group pl-8">
                <span className="absolute left-0 top-0 text-xl transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110">🌸</span>
                <div className="font-bold text-400">software developer</div>
                <div className="text-indigo-400">intact (acquisitions)</div>
                <div className="text-sm text-gray-400">2024</div>
              </div>

              <div className="relative group pl-8">
                <span className="absolute left-0 top-0 text-xl transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110">🌸</span>
                <div className="font-bold text-400">software developer</div>
                <div className="text-indigo-400">rbc (online banking)</div>
                <div className="text-sm text-gray-400">2023</div>
              </div>
            </div>
          </div>

          {/* sidebar */}
          <div className="flex flex-col space-y-4">

            {/* contact */}
            <div className="bg-gray-900 p-4 rounded-md border border-pink-500/30">
              <div className="flex items-center justify-center m-2 space-x-20 text-xl">
                <a href="https://github.com/xaileena" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faGithub} size="2x" className="inline-block text-pink-500 transition duration-300 ease-in-out hover:scale-110"/>
                </a>
                <a href="https://www.linkedin.com/in/aileena-xie/" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faLinkedinIn} size="2x" className="inline-block text-pink-500 transition duration-300 ease-in-out hover:scale-110"/>
                </a>
                <a href="mailto:aileenaxie@gmail.com" target="_blank" rel="noreferrer">
                    <FontAwesomeIcon icon={faEnvelope} size="2x" className="inline-block text-pink-500 transition duration-300 ease-in-out hover:scale-110"/>
                </a>
              </div>
            </div>

            {/* leadership & extracurriculars */}
            <div className="bg-gray-900 p-4 rounded-md border border-pink-500/30 space-y-2">
              <h2 className="text-lg text-pink-400 mb-2"> leadership & extracurriculars</h2>
              <ul className="space-y-2 text-white text-sm">
                <li>
                  <div>mcwics</div>
                  <div className="flex justify-between">
                    <div className="text-xs text-indigo-400">hackathon director</div>
                    <span className="text-gray-400 text-xs">2024 - now</span>
                  </div>
                </li>
                <li>
                  <div>codejam</div>
                  <div className="flex justify-between">
                    <div className="text-xs text-indigo-400">web dev</div>
                    <span className="text-gray-400 text-xs">2023</span>
                  </div>
                </li>
                <li>
                  <div>girls who code</div>
                  <div className="flex justify-between">
                    <div className="text-xs text-indigo-400">facilitator</div>
                    <span className="text-gray-400 text-xs">2022</span>
                  </div>
                </li>
              </ul>
            </div>

            {/* projects */}
            <div className="bg-gray-900 p-4 rounded-md border border-pink-500/30 space-y-4">
              <h2 className="text-lg text-pink-400 mb-2">projects</h2>
                <div className="relative group pl-8">
                  <span className="absolute left-0 top-0 text-xl transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110">★</span>
                  <div className="text-400">bathroombreak</div>
                  <div className="text-xs text-indigo-400">[codejam 2024]</div>
                  <div className="text-xs text-gray-400">your go-to map for gender-neutral, accessible, and well-stocked bathrooms at mcgill</div>
                </div>
                <div className="relative group pl-8 pb-2">
                  <span className="absolute left-0 top-0 text-xl transition-transform duration-300 group-hover:rotate-12 group-hover:scale-110">★</span>
                  <div className="text-400">crypto bot</div>
                  <div className="text-xs text-indigo-400">[mchacks 2023]</div>
                  <div className="text-xs text-gray-400">winner of the tower research capital challenge: a chatbot that makes crypto stats simple and visual</div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}